import React from 'react';
import { Redirect } from 'react-router-dom';
import { GetFormat } from '../../../AppUtil/AppUtil';
import RatingStars from '../../../Component/Profile/BaseProfile/ratingStars';
import Card from '../../Common/Card';
import DetailsRow from './DetailsRow';

import { withRouter } from 'react-router-dom';
import UserService from '../../../Service/UserService';
import './details-style.css';

class Details extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			_balance: 0,
			users: {},
			_loading: false
		};
	}

	setUserType = userType => {
		const typeMap = {
			'NORMAL-USER': <span className="badge badge-pill badge-info">Normal User</span>,
			ACCOUNTING: <span className="badge badge-pill badge-info">ACCOUNTING</span>,
			'CUSTOMER-SERVICE': <span className="badge badge-pill badge-info">CUSTOMER-SERVICE</span>,
			COMMERCIAL: <span className="badge badge-pill badge-info">COMMERCIAL</span>,
			'SUPER-ADMIN': <span className="badge badge-pill badge-danger">SUPER ADMIN</span>,
			ADMIN: <span className="badge badge-pill badge-info">ADMIN</span>,

			default: 'None'
		};
		return typeMap[userType] || typeMap.default;
	};

	formatter = new Intl.NumberFormat('en-PH', {
		style: 'currency',
		currency: 'PHP'
	});

	makeBold = label => {
		return <span className="bold-important">{label}</span>;
	};

	makeBoldTitle = label => {
		return (
			<p
				className="bold-important"
				style={{ background: 'yellow', width: '100%', textAlign: 'center', margin: '0px' }}>
				{label}
			</p>
		);
	};

	updateKycStatus = async () => {
		this.setState({ _loading: true });
		try {
			const users = await UserService.getKycStatus({ id: this.props.match.params.id, action: 'SUBMIT_KYC' });
			if (users) {
				this.setState({ users: users.item, _loading: false });
			}
		} catch (err) {
			this.setState({ _loading: false });
			console.log(err);
		}
	};

	componentDidMount() {
		this.updateKycStatus();
	}

	render() {
		let newAddress = this.props._customer?.address?.split(' ');

		const hasVillage = this.props._customer?.address?.includes('Village');
		const getIndex = newAddress?.indexOf('Village');

		if (getIndex !== -1 && newAddress !== undefined) {
			newAddress[getIndex - 1] = this.props._customer?.address?.split(' ')[getIndex - 1]?.replace('.', '');

			newAddress = Object.values(newAddress)?.join(' ');
		}

		if (this.props._noCustomerFound) {
			return <Redirect to="/admin" />;
		}
		if (!this.props._customer) {
			return 'Loading...';
		}
		const displayRow = [
			//personal information
			[
				{
					id: '0',
					label1: this.makeBoldTitle('PERSONAL INFORMATION'),
					value1: ''
				},
				{
					id: 'p-1',
					label1: this.makeBold('First Name'),
					value1: this.props._customer?.first_name
						? this.props._customer?.first_name
								.split(' ')
								.map(m => m.charAt(0).toUpperCase() + m.slice(1))
								.join(' ')
						: ''
				},
				{
					id: 'p-2',
					label1: this.makeBold('Last Name'),
					value1: this.props._customer.last_name
						? this.props._customer.last_name
								.split(' ')
								.map(m => m.charAt(0).toUpperCase() + m.slice(1))
								.join(' ')
						: ''
				},

				{
					id: 'p-3',
					label1: this.makeBold('Rating'),
					value1: (
						<div style={{ display: 'flex' }}>
							<RatingStars stars={parseFloat(this.props._customer?.rating?.toString())} />/{' '}
							<span className="bold-important">
								{parseFloat(this.state.users?.rating?.toString()) || 0}
							</span>
						</div>
					)
				},
				{
					id: 'p-4',
					label1: this.makeBold('Email'),
					value1: <a href={`mailto:${this.props._customer.email}`}>{this.props._customer.email}</a>
				},
				{
					id: 'p-5',
					label1: this.makeBold('Mobile Number'),
					value1: <span className="bold-important">{this.props._customer.phone}</span>
				},
				{
					id: 'p-6',
					label1: this.makeBold('Birth Date'),
					value1: (
						<span className={this.props._customer.birth_date ? `bold-important` : ''}>
							{this.props._customer.dob ? GetFormat(this.props._customer?.dob) : 'Not Specified'}
						</span>
					)
				},
				{
					id: 'p-7',
					label1: this.makeBold('Address'),
					value1: hasVillage
						? newAddress
							? newAddress.toUpperCase()
							: ''
						: this.props._customer?.address
						? this.props._customer?.address.toUpperCase()
						: ''
				},
				{
					id: 'p-8',
					label1: this.makeBold('City'),
					value1: this.props._customer.city
				},
				{
					id: 'p-9',
					label1: this.makeBold('Region'),
					value1: this.props._customer.state
				},

				{
					id: 'p-10',
					label1: this.makeBold('Postal Code'),
					value1: <span className="bold-important">{this.props._customer.postal_code}</span>
				}
			],
			//lendami app
			[
				{
					id: '1',
					label1: this.makeBoldTitle('LENDAMI APP'),
					value1: ''
				},
				{
					id: 'l-1',
					label1: this.makeBold('User Type'),
					value1: this.setUserType(this.props._customer.user_type)
				},
				{
					id: 'l-2',
					label1: this.makeBold('Tenant'),
					value1: this.props._customer.tenant_full_name
				},
				{
					id: 'l-3',
					label1: this.makeBold('SignUp Date'),
					value1: <span className="bold-important">{GetFormat(this.props._customer.creation_date)}</span>
				}
			],

			//identity verification

			[
				{
					id: '2',
					label1: this.makeBoldTitle('IDENTITY VERIFICATION'),
					value1: ''
				},
				{
					id: 'iv-1',
					label1: this.makeBold('ID Submitted'),
					value1: (
						<span>
							{this.props._customer.id_type
								? JSON.parse(this.props._customer.id_type)?.label
								: 'No ID Submitted'}
						</span>
					)
				},
				{
					id: 'iv-2',
					label1: this.makeBold('Identity Verification Form Submission Date'),
					value1: (
						<span className={this.state.users?.submission_date ? `bold-important` : ''}>
							{this.state.users?.submission_date
								? GetFormat(this.state.users?.submission_date)
								: 'Not Yet Submitted For Kyc'}
						</span>
					)
				},
				{
					id: 'iv-3',
					label1: this.makeBold('Identity Verification Status'),
					value1: <span>{this.state.users?.kyc_status}</span>
				},
				{
					id: 'iv-4',
					label1: this.makeBold('Reason for Rejection'),
					value1: <span>{this.state.users?.reason_of_kyc_rejection || 'No Remarks'}</span>
				}
			],

			//Wallet

			[
				{
					id: '3',
					label1: this.makeBoldTitle('WALLET'),
					value1: ''
				},
				{
					id: 'w-1',
					label1: this.makeBold('Wallet Balance'),
					value1: (
						<span className="bold-important">
							{this.formatter.format(this.state.users?.wallet_balance || 0)}
						</span>
					)
				},

				{
					id: 'w-2',
					label1: this.makeBold('Cashout Channel'),
					value1: <span>{this.props._customer?.bank || 'No Bank Account'}</span>
				}
			]
		];

		return (
			<Card>
				{displayRow.map((row, i) => (
					<div key={`row-${i}`} className="container-customer-profile">
						{row.map(item => (
							<DetailsRow key={item.id} {...item} />
						))}
					</div>
				))}
			</Card>
		);
	}
}

export default withRouter(Details);
